import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Menu, X } from 'lucide-react';

export default function Navbar({ onContact }) {
  const [isOpen, setIsOpen] = useState(false);

  const isHome = window.location.pathname === '/';

  const scrollToTop = () => {
    if (!isHome) {
      window.location.href = '/';
      return;
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
    window.history.pushState(null, '', '/');
  };

  const navItems = [
    { label: 'How It Works', href: isHome ? '#how-it-works' : '/#how-it-works' },
    { label: 'Services', href: isHome ? '#services' : '/#services' },
    { label: 'FAQ', href: isHome ? '#faq' : '/#faq' },
  ];

  return (
    <motion.nav
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="fixed top-0 w-full z-50 glass-dark backdrop-blur-xl border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <motion.div
            whileHover={{ scale: 1.05 }}
            onClick={scrollToTop}
            className="flex items-center gap-3 cursor-pointer"
          >
            <img src="/logo.jpg" alt="Primeslink Logo" className="h-10 w-10 rounded-lg object-cover" />
            <div className="hidden sm:block">
              <div className="text-white font-bold text-lg">Primeslink</div>
            </div>
          </motion.div>

          {/* Desktop Menu */}
          <div className="hidden md:flex gap-8">
            {navItems.map((item) => (
              <motion.a
                key={item.label}
                href={item.onClick ? '#' : item.href}
                target={item.external ? '_blank' : undefined}
                rel={item.external ? 'noopener noreferrer' : undefined}
                onClick={(e) => {
                  if (item.onClick) {
                    e.preventDefault();
                    item.onClick();
                  }
                }}
                whileHover={{ color: '#0ea5e9' }}
                className="flex items-center gap-1.5 text-gray-300 hover:text-primary-500 transition-colors cursor-pointer"
              >
                {item.icon && <item.icon size={16} />}
                {item.label}
              </motion.a>
            ))}
          </div>

          {/* CTA Button */}
          <motion.button
            onClick={onContact}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="hidden md:block px-6 py-2 bg-gradient-to-r from-primary-500 to-accent-500 text-white rounded-lg font-semibold hover:shadow-lg hover:shadow-primary-500/50 transition-shadow cursor-pointer"
          >
            Get in Touch
          </motion.button>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-gray-300"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden pb-4 border-t border-white/10"
          >
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.onClick ? '#' : item.href}
                target={item.external ? '_blank' : undefined}
                rel={item.external ? 'noopener noreferrer' : undefined}
                className="flex items-center gap-1.5 px-4 py-2 text-gray-300 hover:text-primary-500 cursor-pointer"
                onClick={(e) => {
                  if (item.onClick) {
                    e.preventDefault();
                    item.onClick();
                  }
                  setIsOpen(false);
                }}
              >
                {item.icon && <item.icon size={16} />}
                {item.label}
              </a>
            ))}
            <button
              onClick={() => {
                onContact();
                setIsOpen(false);
              }}
              className="w-full mt-2 px-4 py-2 bg-gradient-to-r from-primary-500 to-accent-500 text-white rounded-lg font-semibold cursor-pointer"
            >
              Get in Touch
            </button>
          </motion.div>
        )}
      </div>
    </motion.nav>
  );
}
